import { render } from "./BaseSpinner.vue?vue&type=template&id=54fcf11f&scoped=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=ts"
export * from "./BaseSpinner.vue?vue&type=script&lang=ts"

import "./BaseSpinner.vue?vue&type=style&index=0&id=54fcf11f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54fcf11f"

export default script